import React from 'react';
import Link from 'atomic/link';
import timeStampToDate from 'helpers/time-stamp-to-date';
import AnswerIcon from 'assets/icons/global/ikona-odpowiedz.svg';
import { QuestionsAndAnswersItemInterface } from 'modules/product/views/components/product-questions-answers/interfaces/questions-and-answers-item.interface';

import './product-answer.scss';

interface ProductAnswerProps {
    offerLink?: string;
    createdAt: QuestionsAndAnswersItemInterface['createdAt'];
    text: QuestionsAndAnswersItemInterface['text'];
    author: QuestionsAndAnswersItemInterface['author'];
}

const ProductAnswer: React.FC<ProductAnswerProps> = ({ createdAt, text, offerLink, author }) => {
    return (
        <div className="answer">
            <div className="answer__wrapper">
                <img
                    className="answer__image"
                    src={AnswerIcon}
                    alt={author}
                    width={40}
                    height={40}
                />
                <span className="answer__name">Ekspert Skąpiec.pl</span>
                <span className="answer__date">{timeStampToDate(createdAt).fromNow()}</span>
            </div>
            <p className="answer__text">
                {text}
            </p>
            {offerLink && (
                <p className="answer__offer">
                    Chcesz dowiedzieć się więcej o produkcie?
                    <Link
                        href={offerLink}
                        color="primary"
                        type="button"
                        target="_blank"
                    >
                        Idź do sklepu
                    </Link>
                </p>
            )}
        </div>
    );
};

export default ProductAnswer;
